import { NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';

import logo from './images/logo.png';
import '../App.scss';

function Navbar() {
	const navigate = useNavigate();
	const [searchVal, setSearchVal] = useState("");

	const handleSearch = () => {
		console.log("search val is " + searchVal)
		navigate('/search', {defaultVal: searchVal});
	}
    return (
		<div>
		<div className='flex-row' id='nav'>
			<div className='nav-section'>
				<a href="/"><img src={logo} alt="MERL Logo" id="navLogo"></img></a>
			</div>

		</div>
		<div className='flex-row'>
			<div className='nav-section'>
				{/* TODO: these should probably just be buttons */}
				<div className='navItem'>
					<NavLink to="/search">Reviews</NavLink>
				</div>
				<div className='navItem'>
					<NavLink to="/about">About MERL</NavLink>
				</div>
				<div className='navItem'>
					<NavLink to="/scoring">How We Score</NavLink>
				</div>
				<div className='navItem'>
					<NavLink to="/comingsoon">Articles</NavLink>
				</div>
				<div className='navItem'>
					<NavLink to="/comingsoon">For Educators</NavLink>
				</div>
				<div className='navItem'>
					<NavLink to="/comingsoon">Sign In</NavLink>
				</div>
			</div>
		</div>
		</div>
    )

}

export default Navbar;